import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=4689fb36&scoped=true&"
import script from "./expert.vue?vue&type=script&lang=js&"
export * from "./expert.vue?vue&type=script&lang=js&"
import style0 from "./expert.vue?vue&type=style&index=0&id=4689fb36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689fb36",
  null
  
)

export default component.exports